import React from 'react';

const PanelContext = /*#__PURE__*/React.createContext({
  active: false
});
const usePanelContext = () => React.useContext(PanelContext);

export { PanelContext, usePanelContext };
